import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function BudgetrequestReducer(state = initialState.glaccountContent, action: any) {
  switch (action.type) {
    case types.SAVE_GLACCOUNTCONTENT_SUCCESS:
      return action.glaccountContent;
    default:
      return state;
  }
}
